/**
 * Log level of record.
 */
export enum LogLevel {
    Critical = 1,
    Error,
    Warning,
    Success,
    Informational,
    Verbose,
    Debug
}
